/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateScheduleFilterSettingsRequest} from '@cash-web/protos/squareup/timecards/scheduling/reporting_service.pb'
import {UpdateScheduleFilterSettingsResponse} from '@cash-web/protos/squareup/timecards/scheduling/reporting_service.pb'


export const updateScheduleFilterSettings = (request: UpdateScheduleFilterSettingsRequest, options?: CashRequestOptions) => post<UpdateScheduleFilterSettingsRequest, UpdateScheduleFilterSettingsResponse>("/proxy/services/squareup.timecards.scheduling.PublicSchedulingReportsService/UpdateScheduleFilterSettings", request, {...options, rejectOnError: true })